var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoSlide',{attrs:{"src":require('@/assets/videos/900_Ares_KSAT45_PersonalizedAttackMethods_2025.mp4'),"vtt":require('@/assets/videos/900_Ares_KSAT45_PersonalizedAttackMethods_2025.vtt'),"background-color":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }